/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import {triggerToast} from "helpers";

import {
  modifyFaq,
  fetchFaqs
} from "api";

import EditFaq from "./EditFaq";


const EditFaqContainer = ({
  contentId,
  editFaq,
  setFaqData,
  token,
  setToggleEditFaqPopup
}) => {
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState(editFaq.question);
  const [answer, setAnswer] = useState(editFaq.answer);

  let uploadFaq = {};

  const handleEditFaq = async () => {
    setLoading(true);
    const payload = {
      // eslint-disable-next-line quote-props
      "content_id": contentId,
      question: question?.trim?.() || question,
      answer: answer?.trim?.() || answer
    };
    try {
      uploadFaq = await modifyFaq(token, editFaq.externalId, payload);
      if (uploadFaq && uploadFaq.data.externalId) {
        triggerToast("Faq Updated Successfully", "success");
        try {
          const fetchLatestFaqs = await fetchFaqs();
          setFaqData(fetchLatestFaqs.data.results);
        } catch (err) {
          console.log(err, "error");
        }
        setToggleEditFaqPopup(false);
      }
    } catch (err) {
      setToggleEditFaqPopup(false);
      triggerToast("Error Updating Faq", "error");
    }
    setLoading(false);
  };

  return (
    <EditFaq
      answer={answer}
      handleEditFaq={handleEditFaq}
      loading={loading}
      question={question}
      setAnswer={setAnswer}
      setQuestion={setQuestion}
    />
  );
};

export default EditFaqContainer;
